var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToggleBoth(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.45521 7.14327H11.545C12.2038 7.14327 12.533 6.34564 12.0683 5.8812L8.52478 2.21714C8.37999 2.07234 8.19079 2 8.00169 2C7.81273 2 7.6243 2.07234 7.48074 2.21714L3.93182 5.88174C3.46717 6.3451 3.79618 7.14327 4.45521 7.14327ZM11.5434 8.85745H4.45521C3.79632 8.85745 3.46714 9.65482 3.93185 10.1195L7.48074 13.7836C7.62216 13.9277 7.78822 14 7.99981 14C8.18872 14 8.37801 13.9276 8.52291 13.7828L12.0664 10.1187C12.5317 9.65562 12.2022 8.85745 11.5434 8.85745Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleBoth);
export default __webpack_public_path__ + "static/media/toggle-both.5948f9875cfa77459010acc653385c98.svg";
export { ForwardRef as ReactComponent };